module.exports = __webpack_public_path__ + "img/hb-avant.a8c4de63.jpg";